import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

// Wave-17 Item 1.1 — lazy-loaded route chunk.
export const Route = createFileRoute("/portal/tracker")({
  component: lazyRouteComponent(() => import("@/pages/Portal/Tracker/Page")),
});
